import React from 'react';
import { Link } from 'react-router-dom';
import { Grid, Table, Segment } from 'semantic-ui-react';

const Permissions = ({ permissionData, loading }) => {
  if (loading) {
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Segment style={{ height: '90vh' }} loading={loading} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
  return (
    <Grid centered container padded style={{ marginTop: '0px', padding: '10vh' }}>
      <Grid.Row centered >
        <Grid.Column width={9} >
          <Table singleLine>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Name</Table.HeaderCell>
                <Table.HeaderCell>Description</Table.HeaderCell>
                <Table.HeaderCell>CreatedBy</Table.HeaderCell>
                <Table.HeaderCell>CreatedAt</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {
                permissionData && permissionData.length &&
                permissionData.map((el) => {
                  return (
                    <Table.Row>
                      <Table.Cell>{el.name}</Table.Cell>
                      <Table.Cell>{el.description}</Table.Cell>
                      <Table.Cell>
                        <Link to={`/users/${el.user_id}`}>
                          {el.full_name || 'Not Filled'}
                        </Link>
                      </Table.Cell>
                      <Table.Cell>{new Date(el.created_at).toLocaleDateString()}</Table.Cell>
                    </Table.Row>
                  );
                })
              }
            </Table.Body>
          </Table>

        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default Permissions;



// WEBPACK FOOTER //
// ./src/Modules/Permissions/component.jsx